export default "__VITE_ASSET__Dk77guNi__"